import { getCookie } from '../components/cookie/cookie'

export const scrollToAnchor = (e: React.MouseEvent<HTMLAnchorElement>) => {
  const id: string | undefined = e.currentTarget.href.split('/').pop()

  if (!id) return
  const element: HTMLElement | null = document.getElementById(id)

  const selectedComponent = getCookie('BITRIX_SM_ab_design_code')
  if (selectedComponent === 'new') {
    window.location.hash = id
  }

  if (!element) return

  setTimeout(() => {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, 300)
}
